var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-travel-sausage-group"},_vm._l((_vm.list),function(item,index){return _c('st-travel-sausage',_vm._b({key:((item.text) + "-" + index)},'st-travel-sausage',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }